import { Barlow_Condensed, Manrope } from 'next/font/google';

const manrope = Manrope({
  weight: ['400', '500', '600', '700'],
  subsets: ['latin'],
  display: 'swap', // Prevent invisible text while font loads
});

const barlow = Barlow_Condensed({
  weight: ['600', '700'],
  subsets: ['latin'],
  display: 'swap', // Prevent invisible text while font loads
});

export const fonts = { manrope, barlow };
